/**
 * Shareable agent-chat URL helpers.
 *
 * Canonical route: `/ai-chat/agent-chat/:sessionId`
 *
 * The old Fuse mock contact id (`AGENT_CHAT_CONTACT_ID`) is not a session and must
 * never be written into the address bar as `:sessionId`.
 */

export const AGENT_CHAT_CONTACT_ID = 'ff6bc7f1-449a-4419-af62-b89ce6cae0aa';

export function parseAgentChatSessionParam(
    param: string | number | null | undefined,
): string | null {
    if (param === null || param === undefined) {
        return null;
    }
    const value = String(param).trim();
    if (!value || value === AGENT_CHAT_CONTACT_ID || value === 'datasource') {
        return null;
    }
    return value;
}

const AGENT_CHAT_BASE = '/ai-chat/agent-chat';

export function buildAgentChatConversationCommands(input: {
    sessionId?: string | null;
}): string[] {
    const sessionId = parseAgentChatSessionParam(input.sessionId ?? null);
    return sessionId ? [AGENT_CHAT_BASE, sessionId] : [AGENT_CHAT_BASE];
}

export function agentChatLink(input: {
    sessionId?: string | number | null;
}): string {
    const sessionId = parseAgentChatSessionParam(input.sessionId ?? null);
    return sessionId ? `${AGENT_CHAT_BASE}/${sessionId}` : AGENT_CHAT_BASE;
}

export function agentChatConversationPath(commands: string[]): string {
    return commands
        .map((part, index) => (index === 0 ? part.replace(/\/$/, '') : part))
        .join('/');
}

export function isSameAgentChatConversationUrl(
    currentUrl: string,
    commands: string[],
): boolean {
    const path = currentUrl.split('?')[0].split('#')[0];
    return path === agentChatConversationPath(commands);
}
